import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../../templates/services/base-service.template';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { AppLoginSubjectContainerModel } from '../../models/app/app-login-subject-container.model';
import { getHttpHeader } from '../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class PlatformAuthService implements BaseService {

  public readonly apiUrl: string = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/';
    
  constructor(protected readonly http: HttpClient) {}

  public changeEmail(data: { appLoginSubjectGuid: string, newEmail: string }, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<AppLoginSubjectContainerModel>>{
    return this.http.post<ApiResponseModel<AppLoginSubjectContainerModel>>(`${ api_domain_url }${ this.apiUrl }userprofile/reset-email`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public changePassword(data: { newPassword: string, oldPassword: string }, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.post<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }password/change`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public confirmPhoneVerification(number: string, code: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.post<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }registration/verify_confirmation?number=${ number }&code=${ code }`, {}, getHttpHeader(jwt_secret, tenantCode));
  }

  public forgotPasswordInit(data: { email?: string, mobileNumber?: string, messageTemplate?: string }, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.post<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }password/reset_init`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public forgotPasswordConfirm(data: { confirmationCode: string, email?: string, mobileNumber?: string, newPassword: string }, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.post<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }password/reset_confirm`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public resendEmailVerification(data: { email: string, messageTemplate?: string }, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.post<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }registration/resend_confirmation?tenantCode=${ tenantCode }`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public resendPhoneVerification(number: string, msg: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.post<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }registration/phoneverify?number=${ number }&messageTemplate=${ msg }&tenantCode=${ tenantCode }`, {}, getHttpHeader(jwt_secret, tenantCode));
  }
}
